module.exports = __webpack_public_path__ + "static/media/sidenav-icon-requests.305fdcf6.svg";